<template>
  <div id="app">
    <Header></Header>
    <router-view :key="$route.fullPath" />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue